export const FIELD_TRIP_MODE = 'trip.mode';
export const FIELD_DEPARTURE_CITY = 'location.departure';
export const FIELD_ARRIVAL_CITY = 'location.arrival';
export const FIELD_DEPARTURE_DATE = 'date.departure';
export const FIELD_RETURN_DATE = 'date.return';
export const FIELD_PRODUCTS = 'products';
